import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/civicactions/Sites/data-catalog-components/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Blocks from './index';
import StatBlock from './StatBlock';
import StepsBlock from './StepsBlock';
import './blocks.scss';
import '../../theme/styles/general.scss';
import '../../theme/styles/index.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "blocks"
    }}>{`Blocks`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Blocks} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={1} __code={'<Blocks />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Blocks,
      StatBlock,
      StepsBlock,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Blocks mdxType="Blocks" />
    </Playground>
    <Playground __position={2} __code={'<StatBlock\n  content={{\n    title: \'dkan\',\n    content: \'Foo\',\n  }}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Blocks,
      StatBlock,
      StepsBlock,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StatBlock content={{
        title: "dkan",
        content: "Foo"
      }} mdxType="StatBlock" />
    </Playground>
    <Playground __position={3} __code={'<StepsBlock\n  content={{\n    title: \'dkan\',\n    content: \'Foo\',\n  }}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Blocks,
      StatBlock,
      StepsBlock,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StepsBlock content={{
        title: "dkan",
        content: "Foo"
      }} mdxType="StepsBlock" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      